module.exports = __webpack_public_path__ + "img/mesa_hl32.435c35ed.png";